import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { useCompany } from '../context/CompanyContext';
import './Onboarding.css';

const BIZ_TYPES = [
  { icon: '🏢', name: 'Agency' },
  { icon: '💻', name: 'IT / Tech' },
  { icon: '🛒', name: 'Retail' },
  { icon: '🎓', name: 'Coaching' },
  { icon: '🏥', name: 'Healthcare' },
  { icon: '🍽️', name: 'Restaurant' },
  { icon: '🏗️', name: 'Construction' },
  { icon: '🧑‍💻', name: 'Freelancer' },
  { icon: '✦',  name: 'Other' },
];

const MODULES = [
  { icon: '📊', name: 'CRM + Leads' },
  { icon: '👥', name: 'HR + Attendance' },
  { icon: '💰', name: 'Finance + Billing' },
  { icon: '📋', name: 'Kanban + Projects' },
  { icon: '🤖', name: 'AI Insights' },
  { icon: '💬', name: 'WhatsApp CRM' },
];

const TOTAL_STEPS = 5; // 0=biz 1=company 2=modules 3=team 4=launch

export default function Onboarding() {
  const { theme } = useTheme();
  const { update: updateCompany } = useCompany();
  const navigate = useNavigate();

  const [step, setStep]       = useState(0);
  const [bizType, setBizType] = useState('Agency');
  const [modules, setModules] = useState(['CRM + Leads','HR + Attendance','Finance + Billing']);
  const [email, setEmail]     = useState('');
  const [members, setMembers] = useState([{ email: 'dhanush@ryzenforge.com', role: 'Admin' }]);

  const [co, setCo] = useState({
    name:'', tagline:'', email:'', phone:'',
    website:'', gstin:'', address:'', city:'',
    state:'', pincode:'', country:'India',
  });
  const setCof = (k, v) => setCo(p => ({ ...p, [k]: v }));

  const toggleModule = (name) => setModules(p => p.includes(name) ? p.filter(m=>m!==name) : [...p,name]);
  const addMember = () => {
    if (!email.trim() || members.length >= 5) return;
    setMembers(p => [...p, { email: email.trim(), role: 'Employee' }]);
    setEmail('');
  };
  const updateRole = (i, role) => setMembers(p => p.map((m,idx) => idx===i ? {...m,role} : m));

  const handleLaunch = () => {
    updateCompany(co);
    localStorage.setItem('ryzenos_onboarded', 'true');
    localStorage.setItem('ryzenos_company', JSON.stringify({...co, bizType, modules}));
    navigate('/dashboard');
  };

  return (
    <div className="ob-wrap" data-theme={theme}>
      <div className="ob-glow" />

      <div className="ob-inner">
        {/* Progress dots */}
        <div className="ob-prog">
          {Array.from({ length: TOTAL_STEPS }).map((_, i) => (
            <React.Fragment key={i}>
              <div className={`ob-dot${step===i?' active':step>i?' done':''}`} />
              {i < TOTAL_STEPS - 1 && <div className={`ob-gap${step>i?' done':''}`} />}
            </React.Fragment>
          ))}
        </div>

        {/* ── Step 0: Business type ── */}
        {step === 0 && (
          <>
            <div className="ob-tag">Getting started</div>
            <div className="ob-title">What kind of business<br />are you running?</div>
            <div className="ob-biz-grid">
              {BIZ_TYPES.map(b => (
                <div key={b.name} className={`ob-biz-card${bizType===b.name?' selected':''}`} onClick={() => setBizType(b.name)}>
                  <div className="ob-biz-tick">✓</div>
                  <span className="ob-biz-icon">{b.icon}</span>
                  <div className="ob-biz-name">{b.name}</div>
                </div>
              ))}
            </div>
            <div className="ob-footer">
              <span className="ob-hint">Tap to select</span>
              <button className="ob-next" onClick={() => setStep(1)}>Continue →</button>
            </div>
          </>
        )}

        {/* ── Step 1: Company details ── */}
        {step === 1 && (
          <>
            <div className="ob-tag">Company profile</div>
            <div className="ob-title">Tell us about<br />your company</div>
            <div className="ob-co-form">
              <div className="ob-field-row">
                <div className="ob-field-grp ob-field-grp--wide">
                  <label className="ob-field-lbl">Company name *</label>
                  <input className="ob-field-inp" placeholder="Ryzenforge Enterprises" value={co.name} onChange={e=>setCof('name',e.target.value)} />
                </div>
                <div className="ob-field-grp">
                  <label className="ob-field-lbl">Tagline</label>
                  <input className="ob-field-inp" placeholder="Run your business smarter" value={co.tagline} onChange={e=>setCof('tagline',e.target.value)} />
                </div>
              </div>
              <div className="ob-field-row">
                <div className="ob-field-grp">
                  <label className="ob-field-lbl">Business email *</label>
                  <input className="ob-field-inp" type="email" placeholder="hello@company.in" value={co.email} onChange={e=>setCof('email',e.target.value)} />
                </div>
                <div className="ob-field-grp">
                  <label className="ob-field-lbl">Phone *</label>
                  <input className="ob-field-inp" placeholder="+91 XXXXX XXXXX" value={co.phone} onChange={e=>setCof('phone',e.target.value)} />
                </div>
              </div>
              <div className="ob-field-row">
                <div className="ob-field-grp">
                  <label className="ob-field-lbl">GSTIN</label>
                  <input className="ob-field-inp" placeholder="22AAAAA0000A1Z5" value={co.gstin} onChange={e=>setCof('gstin',e.target.value)} />
                </div>
                <div className="ob-field-grp">
                  <label className="ob-field-lbl">Website</label>
                  <input className="ob-field-inp" placeholder="www.company.in" value={co.website} onChange={e=>setCof('website',e.target.value)} />
                </div>
              </div>
              <div className="ob-field-grp ob-field-grp--full">
                <label className="ob-field-lbl">Address *</label>
                <input className="ob-field-inp" placeholder="Street address, Building no." value={co.address} onChange={e=>setCof('address',e.target.value)} />
              </div>
              <div className="ob-field-row ob-field-row--3">
                <div className="ob-field-grp">
                  <label className="ob-field-lbl">City</label>
                  <input className="ob-field-inp" placeholder="Chennai" value={co.city} onChange={e=>setCof('city',e.target.value)} />
                </div>
                <div className="ob-field-grp">
                  <label className="ob-field-lbl">State</label>
                  <input className="ob-field-inp" placeholder="Tamil Nadu" value={co.state} onChange={e=>setCof('state',e.target.value)} />
                </div>
                <div className="ob-field-grp">
                  <label className="ob-field-lbl">Pincode</label>
                  <input className="ob-field-inp" placeholder="600001" value={co.pincode} onChange={e=>setCof('pincode',e.target.value)} />
                </div>
              </div>
            </div>
            <div className="ob-footer">
              <button className="ob-back" onClick={() => setStep(0)}>Back</button>
              <button className="ob-next" onClick={() => setStep(2)}>Continue →</button>
            </div>
          </>
        )}

        {/* ── Step 2: Modules ── */}
        {step === 2 && (
          <>
            <div className="ob-tag">Modules</div>
            <div className="ob-title">What do you need?</div>
            <div className="ob-mod-grid">
              {MODULES.map(m => (
                <div key={m.name} className={`ob-mod-card${modules.includes(m.name)?' selected':''}`} onClick={() => toggleModule(m.name)}>
                  <div className="ob-mod-icon">{m.icon}</div>
                  <div className="ob-mod-name">{m.name}</div>
                </div>
              ))}
            </div>
            <div className="ob-footer">
              <button className="ob-back" onClick={() => setStep(1)}>Back</button>
              <button className="ob-next" onClick={() => setStep(3)}>Continue →</button>
            </div>
          </>
        )}

        {/* ── Step 3: Team ── */}
        {step === 3 && (
          <>
            <div className="ob-tag">Your team</div>
            <div className="ob-title">Who's joining you?</div>
            <input className="ob-inp" placeholder="Email address" value={email}
              onChange={e=>setEmail(e.target.value)} onKeyDown={e=>e.key==='Enter'&&addMember()} />
            <button className="ob-add-btn" onClick={addMember}>
              {members.length >= 5 ? 'Max 5 members reached' : 'Add member'}
            </button>
            <div className="ob-members">
              {members.map((m, i) => (
                <div key={i} className="ob-member">
                  <div className="ob-member-info">
                    <div className="ob-av">{m.email[0].toUpperCase()}</div>
                    <span className="ob-member-name">{m.email}</span>
                  </div>
                  <select className="ob-role" value={m.role} onChange={e=>updateRole(i,e.target.value)}>
                    <option>Admin</option><option>Manager</option><option>Employee</option>
                  </select>
                </div>
              ))}
            </div>
            <div className="ob-footer">
              <button className="ob-back" onClick={() => setStep(2)}>Back</button>
              <button className="ob-next" onClick={() => setStep(4)}>Continue →</button>
            </div>
          </>
        )}

        {/* ── Step 4: Launch ── */}
        {step === 4 && (
          <>
            <div className="ob-launch">
              <div className="ob-launch-icon">🚀</div>
              <div className="ob-launch-title">You're all set{co.name ? `, ${co.name}` : ''}!</div>
              <div className="ob-launch-sub">Your workspace is ready to go</div>
            </div>
            <div className="ob-review">
              {[
                { label: 'Company',       val: co.name || '—' },
                { label: 'Business type', val: bizType },
                { label: 'Modules',       val: `${modules.length} selected` },
                { label: 'Team members',  val: `${members.length} member${members.length!==1?'s':''}` },
                { label: 'Trial ends',    val: '14 days remaining' },
              ].map(r => (
                <div key={r.label} className="ob-review-item">
                  <span className="ob-review-label">{r.label}</span>
                  <span className="ob-review-val">{r.val}</span>
                </div>
              ))}
            </div>
            <div className="ob-footer">
              <button className="ob-back" onClick={() => setStep(3)}>Back</button>
              <button className="ob-next" onClick={handleLaunch}>Launch workspace →</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
